<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div
          v-show="!showLoader"
          class="row md-flex-dir-col res-width pt-2"
          v-for="(item, i) in userExpiryDetails"
          :key="i"
        >
          <div class="col-8 d-flex pl-5">
            <img
              src="/img/avatars/default-user.png"
              alt="default-user"
              class="img-width"
            />
            <!-- ful name section  -->
            <div class="pl-7">
              <h5 v-if="currentRole === 'doctor' || currentRole === 'allied'" class="tabDataColor tabspace text-capitalize">
                <span v-if="currentRole === 'doctor'">Dr. </span> {{ item.full_name }}
              </h5>
              <h5 v-else class="tabDataColor tabspace">
                {{ item.general.name }}
              </h5>

              <!-- address section -->
              <span
                  v-if="currentRole === 'doctor' || currentRole === 'allied'"
                  class="type capitalize-text"
                  >
                    <span v-if="currentRole === 'doctor'">{{ item.specialities.speciality_type }}</span>
                    <span v-else>
                    <span v-for="speciality, index in item.allied.specialty" :key="index">{{ speciality.specialty_type
                    }}<span v-if="index != item.allied.specialty.length - 1">, </span></span>
                  </span>
                  </span
                >
              <p v-if="currentRole === 'doctor' || currentRole === 'allied'" class="sublocation">
                {{
                  item.address && item.address.current_address
                    ? forShortAddress(item.address.current_address)
                    : ""
                }}
              </p>
              <p v-else class="sublocation">
                {{ forShortAddress(item.general.address) }}
              </p>
            </div>
          </div>
          <div class="col-4 d-flex small-table-padding justify-end pr-6">
            <v-btn
              @click="goToHistoryPage(item)"
              class="btn mr-4 pos-a v-btn view-detail-btn ttc"
            >
              View Details
              <span class="chevarrow pos-r">
                <chevronSVG />
              </span>
            </v-btn>
            <CDropdown
              color="link"
              size="lg"
              :caret="false"
              class="dropdowndocbox subdrop altdropbox border-radius-4"
            >
              <template #toggler-content>
                <verticalDotsSVG />
              </template>
              <CDropdownItem
                @click="goToCall(item.mobile)"
                class="border-bottom tabDataColor"
                >Call</CDropdownItem
              >
              <CDropdownItem
                v-if="currentRole === 'doctor' || currentRole === 'allied' && item.email"
                @click="goToEmail(item.email)"
                class="border-bottom tabDataColor"
                >Email</CDropdownItem
              >
              <CDropdownItem
                v-else
                @click="goToEmail(item.general.contact_email)"
                class="border-bottom tabDataColor"
                >Email</CDropdownItem
              >
              <CDropdownItem class="tabDataColor" @click="sendReminder(item)"
                >Send Reminder</CDropdownItem
              >
            </CDropdown>
          </div>
        </div>
        <div v-if="userExpiryDetails.length <= 0" class="text-center">
          <h2>No Data Found</h2>
        </div>
      </v-card-text>
      <v-skeleton-loader
        v-if="showLoader"
        v-bind="attrs"
        type="list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar"
      ></v-skeleton-loader>
    </v-card>
    <div>
      <pagination
        v-if="!isDashboard && !userExpiryDetails.length <= 0"
        class="mx-6 border-top pt-4"
        :currentPage="currentPage"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
      />
    </div>
    <div
      v-if="!userExpiryDetails.length <= 0 && isDashboard"
      class="btnbox d-flex justify-end pr-5 pb-3"
    >
      <v-btn
        class="
          btn
          mr-4
          pos-a
          v-btn
          ttc
          text-till
          bg-transparent
          box-shadow-none
        "
        @click="goToRecentSubscription(currentRole)"
      >
        View All
        <span class="fillarrowstroke pos-r">
          <chevronSVG />
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import General from "@/methods/utilities.vue";
import { pickSvg } from "@/views/SVG";
import Swal from "sweetalert2";
import config from "@/config.js";
const pagination = () => import("@/views/common/Pagination");
export default {
  mixins: [General],
  props: ["currentRole", "isDashboard"],
  data() {
    return {
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      showLoader: false,
      role: "doctor",
      currentPage: 1,
      recordPerPage: 10,
      currentMonth: false,
      userExpiryDetails: {},
      total: 0,
      sendData: {},
    };
  },
  components: {
    ...pickSvg(
      "crossSVG",
      "verticalDotsSVG",
      "chevronSVG",
      "doctorSVG",
      "ambulanceSVG",
      "upArrowSVG",
      "diagnosticSVG",
      "calendarSVG",
      "pharmacySVG"
    ),
    pagination,
  },
  mounted() {
    this.getUserExpiryList(this.currentRole);
  },

  methods: {
    goToHistoryPage(data) {
      this.sendData = {
        role: this.currentRole,
      };
      if (this.currentRole === "doctor" || this.currentRole === "allied") {
        this.sendData.user_id = data._id;
      } else {
        this.sendData.user_id = data.created_by;
        this.sendData.center_id = data._id;
      }

      this.$router.push({
        name: "Subscription History",
        query: { ...this.sendData },
      });
    },

    goToEmail(email) {
      window.open(`mailto:${email}`);
    },

    goToCall(mobile) {
      Swal.fire({
        title: "Contact No",
        text: mobile,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    },

    getUserExpiryList(currentRole) {
      this.showLoader = true;
      this.isDashboard
        ? (this.currentMonth = true)
        : (this.currentMonth = false);
      let params = {
        role: currentRole ? currentRole : this.currentRole,
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        current_month: this.currentMonth,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/expired-subscription`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.userExpiryDetails = response.body.data.list;
            this.total = response.body.data.count;
          } else {
            this.showLoader = false;
            this.userExpiryDetails = {};
          }
        }
      });
    },

    sendReminder(data) {
      let obj = {
        subscription_id: data.user_subscriptions[0]._id,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/send-reminder`;
      this.$http.post(url, obj).then((response) => {
        if (response.body.status) {
          this.$swal({
            text: "Reminder Sent Successfully!",
            icon: "success",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        }
      });
    },

    // change page logic
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getUserExpiryList(this.currentRole);
    },

    goToRecentSubscription(currentRole) {
      this.$router.push({
        name: "Recently Expired Subscriptions",
        params: { from: currentRole },
      });
    },
  },
  computed: {},
};
</script>